<div class="flex w-full mb-6">
	<header class="page-header flex-auto">
		<h2>Security</h2>
	</header>
	<atomic-message-bar type="info"
		>Changes will apply to all users in your business</atomic-message-bar
	>
</div>
<div class="flex w-full gap-6">
	<app-container class="max-w-500 mb-6 w-1/2">
		<h4 class="mb-2">Auto logout</h4>
		<label class="mb-6"
			>Set a duration of inactivity to automatically logout.</label
		>
		<app-select
			[ngModel]="idleTimeoutMinutes$ | async"
			(ngModelChange)="onIdleTimeoutDurationChange($event)"
			[disabled]="isIdleTimeoutDisabled$ | async"
		>
			<option
				*ngFor="let option of allowedIdleTimeoutOptions"
				[value]="option.value"
			>
				{{ option.label }}
			</option>
		</app-select>
	</app-container>
</div>
